/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Openarialabel3Inputs */

const en_coinvestments_messages_openarialabel3 = /** @type {(inputs: Coinvestments_Messages_Openarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open messages`)
};

/**
* | output |
* | --- |
* | "Open messages" |
*
* @param {Coinvestments_Messages_Openarialabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_openarialabel3 = /** @type {((inputs?: Coinvestments_Messages_Openarialabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Openarialabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_openarialabel3(inputs)
});
export { coinvestments_messages_openarialabel3 as "coInvestments_messages_openAriaLabel" }